import React from 'react';
import { string, func } from 'prop-types';
import { Alert, Link } from '@one-thd/sui-atomic-components';

export const SwapToaster = ({
  itemId,
  swapBack,
  clearSwap
}) => (
  <Alert
    status="success"
    headline="Swap Successful"
    onClose={() => clearSwap(itemId)}
  >
    <div className="sui-flex sui-mt-2">
      <Link
        component="button"
        onClick={() => swapBack(itemId)}
      >Swap Back
      </Link>
    </div>
  </Alert>
);

SwapToaster.propTypes = {
  itemId: string.isRequired,
  swapBack: func.isRequired,
  clearSwap: func.isRequired
};